import { gql } from '@apollo/client';

import {
  AddScreenerQuestionAnswerDocument,
  type AddScreenerQuestionAnswerMutation,
  type AddScreenerQuestionAnswerMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddScreenerQuestionAnswer(
      $input: AddScreenerQuestionAnswerInput!
    ) {
      addScreenerQuestionAnswer(input: $input) {
        status
        projectSessionKey
        disqualificationRedirectUrl
        question {
          id
          text
          type
          questionOrder
          options {
            id
            label
            value
          }
        }
      }
    }
  `;
}

export const ADD_SCREENER_QUESTION_ANSWER = AddScreenerQuestionAnswerDocument;
export type {
  AddScreenerQuestionAnswerMutation,
  AddScreenerQuestionAnswerMutationVariables,
};
